<template>
  <div class="box">
    <admin-box-item title="정렬 설정"
                    :titleFlex="true"
                    bottom-subtitle="유저들이 상품, 파트너, 게시물 정렬 시 사용할 수 있는 기준값을 등록합니다.">
      <div class="columns is-multiline">
        <!-- 상품 -->
        <div class="column is-full">
          <admin-form-item label="상품 정렬"></admin-form-item>
        </div>

        <div class="column is-full">
          <admin-form-item label="사용할 정렬 값">
            <lp-check-group-boolean :list="custom_sort_set.product_set" @selectedItem="res=> selectedItem(res, 'product')"></lp-check-group-boolean>
          </admin-form-item>
        </div>

        <div class="column is-full" v-if="showProductPop">
          <admin-form-item label="인기순 설정">
            <div class="columns is-multiline" style="margin-top: 0">
              <div class="column is-3 flex">
                <lp-percent label="별평점"
                            unit="%"
                            :percent.sync="custom_sort_set.product_pop_percent.review_rate"></lp-percent>
              </div>
              <div class="column is-3 flex">
                <lp-percent label="후기 갯수"
                            unit="%"
                            :percent.sync="custom_sort_set.product_pop_percent.review_count"></lp-percent>
              </div>
              <div class="column is-3 flex">
                <lp-percent label="상품 찜수"
                            unit="%"
                            :percent.sync="custom_sort_set.product_pop_percent.liked_count"></lp-percent>
              </div>
              <div class="column is-3 flex">
                <lp-percent label="상품판매량 수"
                            unit="%"
                            :percent.sync="custom_sort_set.product_pop_percent.order_count"></lp-percent>
              </div>
              <div class="column is-3 flex">
                <lp-percent label="상품 공유 수"
                            unit="%"
                            :percent.sync="custom_sort_set.product_pop_percent.shared_count"></lp-percent>
              </div>
            </div>
          </admin-form-item>
        </div>

        <div class="column is-full" v-if="showProductConversion">
          <admin-form-item :label="showProductConversionTitle">
            <lp-check-group-boolean :list="custom_sort_set.product_conversion"></lp-check-group-boolean>
          </admin-form-item>
        </div>

        <div class="column is-full" v-if="showProductDistance">
          <admin-form-item label="거리순 설정">
            <lp-check-group-boolean :list="custom_sort_set.product_distance"></lp-check-group-boolean>
          </admin-form-item>
        </div>


        <div class="column is-full">
          <div class="lp-border-line"></div>
        </div>

        <!-- 파트너 -->
        <div class="column is-full">
          <admin-form-item label="파트너 정렬"></admin-form-item>
        </div>

        <div class="column is-full">
          <admin-form-item label="사용할 정렬 값">
            <lp-check-group-boolean :list="custom_sort_set.partner_set" @selectedItem="res=> selectedItem(res, 'partner')"></lp-check-group-boolean>
          </admin-form-item>
        </div>

        <div class="column is-full" v-if="showPartnerPop">
          <admin-form-item label="인기순 설정">
            <div class="columns is-multiline" style="margin-top: 0">
              <div class="column is-3 flex">
                <lp-percent label="별 평균평점"
                            unit="%"
                            :percent.sync="custom_sort_set.partner_pop_percent.review_rate"></lp-percent>
              </div>
              <div class="column is-3 flex">
                <lp-percent label="평균 후기 갯수"
                            unit="%"
                            :percent.sync="custom_sort_set.partner_pop_percent.review_count"></lp-percent>
              </div>
              <div class="column is-3 flex">
                <lp-percent label="평균 상품 찜수"
                            unit="%"
                            :percent.sync="custom_sort_set.partner_pop_percent.liked_count"></lp-percent>
              </div>
              <div class="column is-3 flex">
                <lp-percent label="전체 상품판매량 수"
                            unit="%"
                            :percent.sync="custom_sort_set.partner_pop_percent.order_count"></lp-percent>
              </div>
              <div class="column is-3 flex">
                <lp-percent label="평균 상품 공유 수"
                            unit="%"
                            :percent.sync="custom_sort_set.partner_pop_percent.shared_count"></lp-percent>
              </div>
              <div class="column is-3 flex">
                <lp-percent label="컨텐츠 작성 수"
                            unit="%"
                            :percent.sync="custom_sort_set.partner_pop_percent.post_write"></lp-percent>
              </div>
              <div class="column is-3 flex">
                <lp-percent label="컨텐츠 좋아요 수"
                            unit="%"
                            :percent.sync="custom_sort_set.partner_pop_percent.post_liked"></lp-percent>
              </div>
              <div class="column is-3 flex">
                <lp-percent label="컨텐츠 공유 수"
                            unit="%"
                            :percent.sync="custom_sort_set.partner_pop_percent.post_shared"></lp-percent>
              </div>
              <div class="column is-3 flex">
                <lp-percent label="컨텐츠 댓글 수"
                            unit="%"
                            :percent.sync="custom_sort_set.partner_pop_percent.post_comment"></lp-percent>
              </div>
              <div class="column is-3 flex">
                <lp-percent label="컨텐츠 평가점수"
                            unit="%"
                            :percent.sync="custom_sort_set.partner_pop_percent.post_score"></lp-percent>
              </div>
            </div>
          </admin-form-item>
        </div>
        <div class="column is-full">
          <div class="lp-border-line"></div>
        </div>

        <!-- 게시물 -->
        <div class="column is-full">
          <admin-form-item label="게시물 정렬"></admin-form-item>
        </div>

        <div class="column is-full">
          <admin-form-item label="사용할 정렬 값">
            <lp-check-group-boolean :list="custom_sort_set.post_set" @selectedItem="res=> selectedItem(res, 'post')"></lp-check-group-boolean>
          </admin-form-item>
        </div>

        <div class="column is-full" v-if="showPostPop">
          <admin-form-item label="인기순 설정">
            <div class="columns is-multiline" style="margin-top: 0">
              <div class="column is-3 flex">
                <lp-percent label="좋아요 수"
                            unit="%"
                            :percent.sync="custom_sort_set.post_pop_percent.liked_count"></lp-percent>
              </div>
              <div class="column is-3 flex">
                <lp-percent label="공유 수"
                            unit="%"
                            :percent.sync="custom_sort_set.post_pop_percent.shared_count"></lp-percent>
              </div>
              <div class="column is-3 flex">
                <lp-percent label="댓글 수"
                            unit="%"
                            :percent.sync="custom_sort_set.post_pop_percent.comment_count"></lp-percent>
              </div>
              <div class="column is-3 flex">
                <lp-percent label="컨텐츠 평가점수"
                            unit="%"
                            :percent.sync="custom_sort_set.post_pop_percent.score"></lp-percent>
              </div>

            </div>
          </admin-form-item>
        </div>
      </div>
    </admin-box-item>
  </div>
</template>

<script>

  import LpCheckGroupBoolean from "../../../module/common/LpCheckGroupBoolean";
  import LpPercent from "../../../module/common/LpPercent";
  export default {
    name: "ordering-setting",
    components: {
      LpPercent,
      LpCheckGroupBoolean
    },
    props: {
      custom_sort_set: {
        type: Object,
        required:true
      }
    },
    data () {
      return {
        // 인기순 보여주는 여부
        showProductPop: false,
        showPartnerPop: false,
        showPostPop: false,
        showProductConversion: false,
        showProductConversionTitle: '판매량 높은 순',
        showProductDistance: false
      }
    },
    watch: {
      custom_sort_set(n) {
        this.initValue();
      }
    },
    methods: {
      initValue () {
        let product_set = this.custom_sort_set.product_set;
        let distance = find(product_set, 'value', 'distance');
        if(distance) this.showProductDistance = distance.is_active;
        let conversion = find(product_set, 'is_conversion', true);
        if(conversion) {
          this.showProductConversion = conversion.is_active;
          //this.showProductConversionTitle = conversion.label;
        }
        this.showProductPop = this.custom_sort_set.product_set.filter(item=>{ return item.value === '-pop_score'})[0].is_active;
        this.showProductDistance = this.custom_sort_set.product_set.filter(item=>{ return item.value === 'distance'})[0].is_active;
        this.showPartnerPop = this.custom_sort_set.partner_set.filter(item=>{ return item.value === '-pop_score'})[0].is_active;
        this.showPostPop = this.custom_sort_set.post_set.filter(item=>{ return item.value === '-pop_score'})[0].is_active;
      },
      // 체크박스 선택시 호출
      selectedItem (res, type) {
        switch(type) {
          case 'product':
            if(res.value==='-pop_score') {
              this.showProductPop = res.is_active;
            }
            else if(res.value==='distance') {
              this.showProductDistance = res.is_active;
            }
            // 주문 많은 순 설정
            else if(res.is_conversion) {
              this.showProductConversion = res.is_active;
              //this.showProductConversionTitle = res.label;
            }
            break;
          case 'partner':
            if(res.value==='-pop_score') {
              this.showPartnerPop = res.is_active;
            }
            break;
          case 'post':
            if(res.value==='-pop_score') {
              this.showPostPop = res.is_active;
            }
            break;
        }
      },
    }
  }
</script>

<style scoped>

</style>
